import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const CodeBookDropdownOptions = [
  'Diagnosis, ICD-10-CM',
  'External Cause, ICD-10-CM',
  'Procedure, ICD-10-PCS',
];

export type SearchMode = 'index'|'table'|'';

export const useSearchStore = defineStore('searchStore', () => {

  const bookSelected = ref(CodeBookDropdownOptions[0]);
  const getBookSelected = computed(() => bookSelected.value);
  const getBookTitle = computed(() => {
    if (CodeBookDropdownOptions.includes(bookSelected.value)) {
      const bookNameSplit = bookSelected.value.split(', ');
      const bookTitle = bookNameSplit.length > 1 ? bookNameSplit[1] +  ' ' + bookNameSplit[0] : bookSelected.value;
      return bookTitle + ' Index';
    } else {
      return '';
    }
  });
  const isProceduresBookSelected = computed(() => bookSelected.value === 'Procedure, ICD-10-PCS');
  const modeSelected = ref<SearchMode>('');
  const isTableModeSelected = computed(() => modeSelected.value == 'table');

  function setBookSelected(book: string) {
    bookSelected.value = book;
    //if procedures book is selected mode should be set to default (index), otherwise mode cannot be set and should be empty
    setModeSelected(isProceduresBookSelected.value ? 'index' : '');
  }

  function setModeSelected(mode: SearchMode) {
    modeSelected.value = mode;
  }

  return {
    modeSelected,
    bookSelected,
    isTableModeSelected,
    getBookSelected,
    getBookTitle,
    isProceduresBookSelected,
    setModeSelected,
    setBookSelected
  }
});
